import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';

var _templateObject;
var derriveLeft = function derriveLeft(_ref) {
  var _ref$on = _ref.on,
    on = _ref$on === void 0 ? false : _ref$on;
  return !!on ? 'calc(0% + .5rem)' : 'calc(100% - (18px + .5rem))';
};
var derriveFontWeight = function derriveFontWeight(_ref2) {
  var _ref2$on = _ref2.on,
    on = _ref2$on === void 0 ? false : _ref2$on;
  return on ? 'bold' : undefined;
};
var StyledSpan = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: ", ";\n  left: ", ";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n"])), derriveFontWeight, derriveLeft);
var Indicator = function Indicator(_ref3) {
  var on = _ref3.on,
    toggleSize = _ref3.toggleSize;
  if (toggleSize !== 'large') {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", null, on ? 'On' : 'Off');
};
var ToggleLabel = function ToggleLabel(_ref4) {
  var id = _ref4.id,
    on = _ref4.on,
    toggleSize = _ref4.toggleSize;
  return /*#__PURE__*/React.createElement(StyledSpan, {
    id: id,
    on: on,
    toggleSize: toggleSize
  }, /*#__PURE__*/React.createElement(Indicator, {
    on: on,
    toggleSize: toggleSize
  }));
};
var ToggleSwitchLabel = /*#__PURE__*/memo(ToggleLabel);

export default ToggleSwitchLabel;
